import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { baseUrls } from '../appConstant';
import { GlobalServices } from '../global.services';
import { UserDashboardService } from '../services/user-dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  baseUrl = baseUrls.global;
  imageUrl = baseUrls.images;
  constructor(private globalServices: GlobalServices,
    private router: Router,
    private userDashboardService: UserDashboardService) { }
  userImage = this.globalServices.imgSrc;
  userInfo = JSON.parse(localStorage.getItem('userDetails'));
  ngOnInit(): void {
    // this.globalServices.viewcontainerhelper.clear();
    if (this.globalServices.isBrowser) {
      if(this.globalServices.isLoggedIn == true){
        this.mode = 'indeterminate'; 
        // this.router.navigate(['home']); // cross check it usage
        this.slickSlider();
        this.getUserRecommendation();
        this.loadOverView();
        this.getUserPlaylist(0,5);
        this.loadMySchedule();
        this.loadRecommendedTrips(this.userInfo?._id);
        setTimeout(()=>{
          this.moveToTop();
        },1000);
      }
      else{
        this.router.navigate(['']);
      }
    }
    else{
      this.router.navigate(['']);
    }
  }
  moveToTop(){
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  slideConfig3 = {};
  slideConfig2 = {};
  slideConfig: {};
  slickSlider() {
    this.slideConfig = {
      "slidesToShow": 2,
      "slidesToScroll": 1,
      "infinite": false,
      "responsive": [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 839,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            arrows: true
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: true
          },
        },
      ]
    };
    this.slideConfig2 = {
      "slidesToShow": 3,
      "slidesToScroll": 1,
      "infinite": false,
      "responsive": [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 676,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        }, 
      ]
    }
    this.slideConfig3 = {
      "slidesToShow": 4,
      "slidesToScroll": 1,
      "infinite": false,
      "responsive": [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 676,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        }, 
      ]
    }
  }
  backgroundColorInOverviewSection(indexValue){
    if(indexValue == 'totalClassCompleted' ){
      return '#F2CC5B';
    }
    if(indexValue == 'rewardPoints' ){
      return '#503E9D';
    }
    if(indexValue == 'totalRatings' ){
      return '#CCC1EB';
    }
    if(indexValue == 'totalWatchTime' ){
      return '#EB6297';
    }
  }
 
  routeToSurvey(){
    if(this.globalServices.isLoggedIn == true){
      this.router.navigate(['survey']);
    }else{
      this.router.navigate(['']);
    }
  }

  userRecommendedData;
  mode = 'determinate';
  getUserRecommendation(){
    this.mode = 'indeterminate';
    this.userDashboardService.userRecommendedData().subscribe((resOfUserRecommendedData: any) => {
      if(resOfUserRecommendedData){
        this.userRecommendedData = resOfUserRecommendedData.data;
        this.mode = 'determinate';
      }      
    })
  }
  userOverView:Array<Object>=[];
  public over_view = ['totalClassCompleted','rewardPoints','totalWatchTime','totalRatings']; 
  loadOverView(){
    // this.mode = 'indeterminate';
    this.userDashboardService.userOverViewdData().subscribe((userOverViewData: any) => {
      // this.mode = 'determinate';
      if(userOverViewData?.data){
        for (var property in userOverViewData.data) {
          if (userOverViewData.data.hasOwnProperty(property)) {
            if(property !='totalReviews'){
            if(property =='rewardPoints'){
              this.userOverView.push({
                name:property,
                value:userOverViewData.data[property]['pointsEarned']
              })
            }else{
            this.userOverView.push({
              name:property,
              value:userOverViewData.data[property]
            })
          }      
          }
        }
        }
        for(let i=0;i<this.over_view.length;i++){
          for(let j=0;j<this.userOverView.length;j++){
              if(this.over_view[i]==this.userOverView[j]['name']){
                this.desired_array.push(this.userOverView[j]);
                break;
              }
          }
        }
      }      
    })
  }
  public desired_array=[];
  savePlaylist = [ ];
  resOfPlaylistMessage: string = 'No playlist !!';
  getUserPlaylist(startPassed, lengthPassed){
    if((startPassed || startPassed == 0) && lengthPassed){      
      this.userDashboardService.userPlaylistData(startPassed, lengthPassed).subscribe((resOfUserPlaylist: any) => {
        if(resOfUserPlaylist?.message){
          this.resOfPlaylistMessage = resOfUserPlaylist?.message; 
        }
        if(resOfUserPlaylist?.data){
          this.savePlaylist = [...this.savePlaylist, ...resOfUserPlaylist?.data?.data];
        }

      },
      (error: any) => {
        if(error.message){
          this.resOfPlaylistMessage = error?.error?.message; 
        }
      });
    }
  }

  scheduleData;
  loadMySchedule(){
    this.userDashboardService.getSchedules().subscribe((resOfSchedules: any) => {
      if(resOfSchedules){
        this.scheduleData = resOfSchedules;
      }
    });
  }

  goToPlaylistPage(playlistInfo){
    if(playlistInfo){
      window.location.href = this.baseUrl + `livewell/playlist/${playlistInfo?._id}`
    }
  }

  recommendedTrips = [];
  loadRecommendedTrips(userId){
    this.userDashboardService.getRecommendedTrips(userId).subscribe((resOfUserRecommendedTrips: any) => {
      if(resOfUserRecommendedTrips){
        this.recommendedTrips = resOfUserRecommendedTrips.data;
      }
    });
  }

  moveToSelectedRecommendedTrip(recommendedTripInfo){
    if(recommendedTripInfo){
      // this.router.navigate([''])
      window.location.href = this.baseUrl+ 'travel/destinations/' + recommendedTripInfo.region.slug + '/' + recommendedTripInfo.country.slug + '/' + recommendedTripInfo.categoryName + '/' + recommendedTripInfo.slug;
    }
  }
  moveToBuyPlanRoute(){
    window.location.href = 'https://mytripwell.clientwork.xyz/plan';
  }

  routeToSurveyOnEdit(){
    if(this.globalServices.isLoggedIn == true){
      this.router.navigate(['survey',{ edit : true}]);
    }else{
      this.router.navigate(['']);
    }
  }
}
